import { useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import DetailForm from "./DetailForm";
import Table from "./table/Datatable";

export const AIOnboarding = () => {

    const [record, setRecord] = useState(null);
    const [value, setValue] = useState(new Date().getTime());


    const updateRecord = (rec) => {
        setRecord(rec)
    }

    function reloadComponent() {
        setRecord(null)
        setValue(new Date().getTime());
    }

    return (


        <div style={{ height: "100%" }}>
            {value &&

                <Container fluid className="h-full">
                    <iframe src="https://onboarding.1dride.com/1dride_onboarding/" className="h-full w-full"></iframe>
                </Container>

            }
        </div>

    );

}